import { ChargebackEventStatus, ChargebackEventStatusEnum } from '@/enums/chargeback-status.enum';

export const resolveEventStatusVariant = (status) => {
    switch (status) {
      case ChargebackEventStatusEnum.PENDING:
      case ChargebackEventStatusEnum.EXPIRED:
      case ChargebackEventStatusEnum.DECLINED:
        return 'error';
      case ChargebackEventStatusEnum.DELETED:
        return '';
      default:
        return 'success';
    }
};

export const chargebackEventStatusMapper = (status) => {
  const option = ChargebackEventStatus.find(option => option.value === status);
  if (option) {
    return option.title;
  }

  return status;
};
